/*eslint-disable*/
import './item-status.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import PlannedIcon from '../../../../assets/images/public/p-planned-icon.svg';
import ProgressIcon from '../../../../assets/images/public/p-progress-icon.svg';
import CompleteIcon from '../../../../assets/images/public/p-complete-icon.svg';
import OpenIcon from '../../../../assets/images/public/p-open-icon.svg';


const ItemStatus = ({
    itemInfo,
    roadmapDetails,
    listType,
}) => {

    const getReqStatus = (status) => {
        if (status === 'open' || status === 'Open') {
            return 'Open';
        } else if (status === 'planned') {
            return 'Planned';
        } else if (status === 'progress') {
            return 'Under progress';
        } else if (status === 'complete') {
            return 'Complete';
        } else if (status === 'trash') {
            return 'Trash';
        } else if (status === 'pending') {
            return 'Pending';
        }
    };

    const getIcon = (status) => {
        if (status === 'planned') {
            return <img src={PlannedIcon} className="status-icon" />;
        } else if (status === 'progress') {
            return <img src={ProgressIcon} className="status-icon" />;
        } else if (status === 'complete') {
            return <img src={CompleteIcon} className="status-icon" />;
        } else if (status === 'open' || status === 'Open') {
            return <img src={OpenIcon} className="status-icon" />;
        } else if (status === 'trash') {
            return <FontAwesomeIcon icon={faTrash} className="status-icon" />;
        }
    }

    return (
        <div className="item-status">
            <div className={`req-status ${roadmapDetails ? 'details-part' : ''} ${listType} pl-${itemInfo?.status}`}>
                <span className="req-status-icon">
                    {getIcon(itemInfo?.status)}
                </span>
                {getReqStatus(itemInfo?.status)}
            </div>
        </div>
    );
};

export default ItemStatus;
